module.exports = "https://cdn.dove.it/_next/static/public/assets/features/buy-from-agency.777877364180bee08e974ee9e31645ec.jpg";